import createUpload from "@ai/mss-upload-js";
import randomString from "randomstring";
import PreviewJpgFile from "@/assets/images/marketJpgFile.png";
import PreviewPngFile from "@/assets/images/marketPngFile.png";
import PreviewGifFile from "@/assets/images/marketGifFile.png";
import PreviewWebpFile from "@/assets/images/marketWebpFile.png";
import PreviewAiFile from "@/assets/images/marketAiFile.png";
import PreviewC4DFile from "@/assets/images/marketC4DFile.png";
import PreviewEpsFile from "@/assets/images/marketEpsFile.png";
import PreviewMp3File from "@/assets/images/marketMp3File.png";
import PreviewMp4File from "@/assets/images/marketMp4File.png";
import PreviewPdfFile from "@/assets/images/marketPdfFile.png";
import PreviewPsdFile from "@/assets/images/marketPsFile.png";
import PreviewSketchFile from "@/assets/images/marketSketchFile.png";
import PreviewZipFile from "@/assets/images/marketZipFile.png";
import Preview3DFile from "@/assets/images/market3DFile.png";
import PreviewAeFile from "@/assets/images/marketAeFile.png";
import PreviewJsonFile from "@/assets/images/marketJsonFile.png";
import PreviewKeyFile from "@/assets/images/marketKeyFile.png";
import PreviewWordFile from "@/assets/images/marketWordFile.png";
import PreviewMgFile from "@/assets/images/marketMgFile.png";
import { currentInitConfig } from "./init";

export function formatFileSize(fileSize = 0) {
    if (fileSize < 1024) {
        return parseInt(fileSize) + "B";
    }
    fileSize = fileSize / 1024;
    if (fileSize < 1024) {
        return parseInt(fileSize) + "KB";
    }
    fileSize = fileSize / 1024;
    if (fileSize < 1024) {
        return parseInt(fileSize) + "MB";
    }
    fileSize = fileSize / 1024;
    return parseInt(fileSize) + "G";
}

export async function getFileSizeByUrl(url) {
    const data = await fetch(url);
    const size = data.headers.get("Content-Length") || 0;
    return formatFileSize(size);
}

export function getFileSize(file, unit = "KB") {
    const fileSize = (file && file.size) || 0;
    if (unit === "KB") {
        return parseInt((fileSize * 100) / 1024, 10) / 100;
    }
    if (unit === "MB") {
        return parseInt((fileSize * 100) / (1024 * 1024), 10) / 100;
    }
    if (unit === "G") {
        return parseInt((fileSize * 100) / (1024 * 1024 * 1024), 10) / 100;
    }
    return fileSize;
}

// 判断是否需要分片上传
export function shouldSliceUpload(file) {
    const fileSize = getFileSize(file, "MB");
    // return {
    //     sliceState: true,
    //     sliceSize: 1024 * 1024 * 5
    // }
    if (fileSize < 100) {
        return {
            sliceSize: 0,
            sliceState: false
        };
    } else if (fileSize < 500) {
        return {
            sliceState: true,
            sliceSize: 1024 * 1024 * 50
        };
    } else if (fileSize < 1024) {
        return {
            sliceState: true,
            sliceSize: 1024 * 1024 * 100
        };
    } else {
        return {
            sliceState: true,
            sliceSize: 1024 * 1024 * 150
        };
    }
}

export function initUploadInstance(opts, mode = 1) {
    // 1：普通上传  2：分片上传，需要和加签方法一一对应
    let signatureUrl = "/mtd-api/assets-internal/v2/upload/getUploadSign";
    let sliceSize = 1024 * 1024 * 5;
    if (mode === 2) {
        signatureUrl = "/mtd-api/assets-internal/v2/upload/multiUploadSign";
        sliceSize = opts.sliceSize || sliceSize;
    }
    const { s3Config } = currentInitConfig();
    return createUpload(
        Object.assign(
            {},
            {
                signatureUrl: signatureUrl, //加签接口url
                bucket: s3Config.bucket, //桶
                hashMode: true, //Boolean,选传，标示上传后的文件名是否有唯一性，默认为 false：使用传入的key或原始文件名；true: 使用当前时间戳加签生成的字符串做文件名
                prefix_type: "s3_style", // 迁移服务密钥
                s3_host: s3Config.endpoint,
                isHttps: true,
                validateFile(file) {
                    //验证选择的文件是否符合预期，return true则继续，return false则中止后续流程
                    return true;
                },
                onProgress: percent => {
                    //上传进度回调
                },
                onStart: function() {}, //上传开始回调
                onSuccess: fileUrl => {},
                onError(errorMsg) {
                    console.error(errorMsg); //上传失败回调
                }
            },
            opts
        ),
        mode
    );
}
// 本地获取图片宽高
export async function getImageInfo(imageFile) {
    return new Promise(resolve => {
        const reader = new FileReader();
        reader.readAsDataURL(imageFile);
        reader.onload = e => {
            // 普通img资源文件
            const image = new Image();
            image.onload = image => {
                const { width, height } = image.target;
                const orientation =
                    width >= height ? (width === height ? 3 : 1) : 2; // 1-横图，2-竖图，3-方图
                resolve({
                    width: width || 0,
                    height: height || 0,
                    orientation
                });
            };
            image.onerror = () => {
                resolve({
                    width: 0,
                    height: 0,
                    orientation: 3
                });
            };
            image.src = e.target.result;
        };
    }).catch(() => ({}));
}
// 获取远程图片宽高
export async function getImageWidth(url) {
    return new Promise(resolve => {
        const image = new Image();
        image.onload = image => {
            const { width, height } = image.target;
            const orientation =
                width >= height ? (width === height ? 3 : 1) : 2; // 1-横图，2-竖图，3-方图
            resolve({
                width: width || 0,
                height: height || 0,
                orientation
            });
        };
        image.onerror = e => {
            resolve({
                width: 0,
                height: 0,
                orientation: 3
            });
        };

        image.src = url;
    }).catch(() => ({
        width: 0,
        height: 0,
        orientation: 3
    }));
}

export async function getVideoInfo(file) {
    return new Promise(function(resolve, reject) {
        const videoElem = document.createElement("video");
        const dataUrl = URL.createObjectURL(file);

        // 当前帧的数据是可用的
        videoElem.onloadeddata = function() {
            const canvasElem = document.createElement("canvas");
            const { videoWidth, videoHeight, duration } = videoElem;
            canvasElem.width = videoWidth;
            canvasElem.height = videoHeight;
            canvasElem
                .getContext("2d")
                .drawImage(videoElem, 0, 0, videoWidth, videoHeight);
            // 导出成blob文件
            canvasElem.toBlob(blob => {
                // 将blob文件转换成png文件
                const thumbFile = new File([blob], "thumb__img.png");
                const uploadInstance = initUploadInstance(
                    {
                        file: thumbFile,
                        onStart: () => {},
                        onProgress: percent => {},
                        onSuccess: fileUrl => {
                            resolve({
                                duration: duration,
                                width: videoWidth,
                                height: videoHeight,
                                previewImageUrl: fileUrl
                            });
                        },
                        onError: err => {
                            console.log("视频封面图生成失败 ->", err);
                        }
                    },
                    1
                );
                uploadInstance.upload();
            }, "image/png");
        };
        videoElem.onerror = function() {
            reject("video 后台加载失败");
        };
        // 设置 auto 预加载数据， 否则会出现截图为黑色图片的情况
        videoElem.setAttribute("preload", "auto");
        videoElem.src = dataUrl;
    });
}

export function generateId() {
    const now = new Date();
    const year = now.getFullYear();
    let month = now.getMonth() + 1;
    let day = now.getDate();
    let hour = now.getHours();
    let minutes = now.getMinutes();
    let seconds = now.getSeconds();
    if (String(month).length < 2) {
        month = "0" + month;
    }
    if (String(day).length < 2) {
        day = "0" + day;
    }
    if (String(hour).length < 2) {
        hour = "0" + hour;
    }
    if (String(minutes).length < 2) {
        minutes = "0" + minutes;
    }
    if (String(seconds).length < 2) {
        seconds = "0" + seconds;
    }
    const yyyyMMddHHmmss = `${year}${month}${day}${hour}${minutes}${seconds}`;
    const prefix = randomString.generate({
        length: 3,
        readable: true,
        charset: "alphabetic"
    });
    return `${prefix}_${yyyyMMddHHmmss}`;
}

export function getFilePreviewUrl(type, fileName) {
    let fileExtension = "";
    if (fileName && fileName.includes(".")) {
        const nameArr = fileName.split(".");
        fileExtension = nameArr[nameArr.length - 1];
    }
    let fileType = FileMimeType.find(item => {
        if (
            item.mimeType.toUpperCase() === type.toUpperCase() ||
            item.extension.toUpperCase() === fileExtension.toUpperCase()
        ) {
            return true;
        }
    });

    return fileType ? fileType.previewFile : PreviewJpgFile;
}

export function getFileExtension(type, fileName = "") {
    let fileExtension = "";
    if (fileName && fileName.includes(".")) {
        const nameArr = fileName.split(".");
        fileExtension = nameArr[nameArr.length - 1];
    }
    let fileType = FileMimeType.find(item => {
        if (
            item.mimeType.toUpperCase() === type.toUpperCase() ||
            item.extension.toUpperCase() === fileExtension.toUpperCase()
        ) {
            return true;
        }
    });

    return fileType ? fileType.extension : "";
}

export const FileMimeType = [
    {
        mimeType: "image/jpeg",
        extension: "jpeg",
        previewFile: PreviewJpgFile
    },
    {
        mimeType: "image/png",
        extension: "png",
        previewFile: PreviewPngFile
    },
    {
        mimeType: "image/gif",
        extension: "gif",
        previewFile: PreviewGifFile
    },
    {
        mimeType: "image/webp",
        extension: "webp",
        previewFile: PreviewWebpFile
    },
    {
        mimeType: "image/tiff",
        extension: "tiff",
        // tiff暂时用jpeg的
        previewFile: PreviewJpgFile
    },
    {
        mimeType: "application/postscript",
        extension: "ai",
        previewFile: PreviewAiFile
    },
    {
        mimeType: "application/vnd.clonk.c4group",
        extension: "c4d",
        previewFile: PreviewC4DFile
    },
    {
        mimeType: "application/postscript",
        extension: "eps",
        previewFile: PreviewEpsFile
    },
    {
        mimeType: "audio/mp3",
        extension: "mp3",
        previewFile: PreviewMp3File
    },
    {
        mimeType: "video/mp4",
        extension: "mp4",
        previewFile: PreviewMp4File
    },
    {
        mimeType: "video/avi",
        extension: "avi",
        previewFile: PreviewMp4File
    },
    {
        mimeType: "video/mpg",
        extension: "mpg",
        previewFile: PreviewMp4File
    },
    {
        mimeType: "video/mpeg",
        extension: "mpeg",
        previewFile: PreviewMp4File
    },
    {
        mimeType: "application/pdf",
        extension: "pdf",
        previewFile: PreviewPdfFile
    },
    {
        mimeType: "image/vnd.adobe.photoshop",
        extension: "psd",
        previewFile: PreviewPsdFile
    },
    {
        mimeType: "application/zip",
        extension: "zip",
        previewFile: PreviewZipFile
    },
    {
        mimeType: "application/msword",
        extension: "doc",
        previewFile: PreviewWordFile
    },
    {
        mimeType:
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        extension: "docx",
        previewFile: PreviewWordFile
    },
    {
        mimeType: "",
        extension: "sketch",
        previewFile: PreviewSketchFile
    },
    {
        mimeType: "mglink",
        extension: "mglink",
        previewFile: PreviewMgFile
    },
    {
        mimeType: "application/vnd.ms-powerpoint",
        extension: "ppt",
        previewFile: PreviewWordFile
    },
    {
        mimeType: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        extension: "pptx",
        previewFile: PreviewWordFile
    }
];

// 文件类型信息分类
// 封面图
export const UploadImageType = {
    maxSizeLimit: {
        size: 50,
        unit: "MB"
    },
    accept: "image/jpeg,image/png,image/gif,image/webp,image/tiff"
};

export const UploadVideoType = {
    maxSizeLimit: {
        size: 500,
        unit: "MB"
    },
    accept: "video/mp4,video/avi,video/mpg,video/mpeg"
};

// 营销上传文件类型
export const UploadMarketMaterialFileType = {
    maxSizeLimit: {
        size: 3 * 1024,
        unit: "MB"
    },
    accept:
        "application/postscript,.c4d,application/postscript,image/jpeg,audio/mp3,video/mp4,application/pdf,image/png,image/vnd.adobe.photoshop,application/zip,image/gif"
};
// 设计资产上传文件类型
export const UploadDesignFileType = {
    maxSizeLimit: {
        size: 500,
        unit: "MB"
    },
    accept:
        ".sketch,application/postscript,.c4d,application/postscript,image/jpeg,audio/mp3,video/mp4,application/pdf,image/png,image/vnd.adobe.photoshop,application/zip,image/gif,.ppt,application/vnd.ms-powerpoint,.pptx,application/vnd.openxmlformats-officedocument.presentationml.presentation"
};
// 品牌资产上传文件类型
export const UploadBrandMaterialFileType = {
    maxSizeLimit: {
        size: 100,
        unit: "MB"
    },
    accept: "application/postscript,image/jpeg,image/png,image/gif,image/webp"
};

// 图标上传文件类型
export const UploadIconFileType = {
    maxSizeLimit: {
        size: 2,
        unit: "MB"
    },
    typeList: [
        {
            mimeType: "image/svg+xml",
            extension: "svg"
        }
    ],
    accept: "image/svg+xml"
};
// 协议上传类型
export const UploadCopyrightFileType = {
    maxSizeLimit: {
        size: 10 * 1024,
        unit: "MB"
    },
    accept:
        "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/jpeg,application/pdf,image/png"
};

// 以图搜图
export const SearchImageType = {
    maxSizeLimit: {
        size: 10,
        unit: "MB"
    },
    accept: "image/jpeg,image/png,image/gif,image/webp,image/tiff"
};

export const UploadSourceType = {
    ALL: -1,
    FILE: 1,
    MG_LINK: 2,
    LINK: 3
};

export function removeFileExtension(fileName) {
    if (!fileName) {
        return "";
    }
    const nameArr = fileName.split(".");
    if (nameArr.length > 1) {
        const newArr = nameArr.slice(0, nameArr.length - 1);
        const newName = newArr.join("");
        return newName.length > 20 ? newName.substring(0, 20) : newName;
    } else {
        return fileName.length > 20 ? fileName.substring(0, 20) : fileName;
    }
}
